<app-dialog-warning-delete
  (passEntry)="onConfirm($event)"
  [loading]="loading"
  [msgVald]="-1"
  [mainTitle]="''"
  [headerTitleOverride]="headerTitle"
  [customBodyMessage]="bodyMessage"
  [primaryButtonClass]="'btn-primary'"
  [loadingButtonText]="'Aplicando...'"
  [confirmButtonText]="'Aceptar'"
>
</app-dialog-warning-delete>
